import { Chip } from '@mui/material';
import { useACHLocationStatus } from './ach-location-status-chip.hooks';
import { useTranslation } from 'react-i18next';
import {
  ACHFundingAccountStatusType,
  ACHLocationStatusType,
  BeneficialOwnerStatusType,
} from 'api/giftcard-ach-service/giftcard-ach-service.types';

type ACHLocationStatusChipProps = {
  status:
    | ACHLocationStatusType
    | ACHFundingAccountStatusType
    | BeneficialOwnerStatusType;
};

const ACHLocationStatusChip = ({ status }: ACHLocationStatusChipProps) => {
  const { t } = useTranslation();
  const { label, color } = useACHLocationStatus(status);

  if (!label)
    return (
      <Chip
        label={t(
          'page.giftCards.moneyMovement.sections.accountConfiguration.statuses.notEnrolled',
        )}
        size="small"
        data-testid="ACHLocationStatusChip"
      />
    );

  return (
    <Chip
      label={label}
      color={color}
      size="small"
      data-testid="ACHLocationStatusChip"
    />
  );
};

export default ACHLocationStatusChip;
